import i18n from './i18n';
import { getTranslationValue } from './translations';
import { NewOrder_OrderFieldsFragment, OrderDomain } from '@/types';
import type { OrderSummaryInput } from '@domain/configuration/types';

export const DEFAULT_CART_KEY = 'default';

export interface InputValueMap {
  [id: string]: { title: string; value: string };
}

export const getOrderSummaryInputError = (
  input: OrderSummaryInput,
  value: string,
): string | null => {
  if (input.required && !value) {
    return i18n.t('field_is_required');
  }

  if (input.pattern && value && !new RegExp(input.pattern).test(value)) {
    return input.pattern_invalid_message
      ? getTranslationValue(input.pattern_invalid_message)
      : i18n.t('field_is_invalid');
  }

  return null;
};

/** The default cart is the GLOBAL draft; named carts are STOREFRONT. */
export const isDefaultCart = (
  order: Pick<NewOrder_OrderFieldsFragment, 'order_domain'>,
) => order.order_domain === OrderDomain.Global;

export const getCartKeyForOrder = (
  order:
    | Pick<NewOrder_OrderFieldsFragment, 'order_domain' | 'uuid'>
    | null
    | undefined,
) => (!order || isDefaultCart(order) ? DEFAULT_CART_KEY : order.uuid);

export const mergeItems = (
  items: NewOrder_OrderFieldsFragment['orders_items'],
) => {
  // Initialize a result array to hold merged results
  const result: NewOrder_OrderFieldsFragment['orders_items'] = [];

  // Iterate through the input items
  items.forEach((item) => {
    // Find an existing item in the result based on 'variants_pack.uuid'
    const existingItem = result.find(
      (mi) => mi.variants_pack.uuid === item.variants_pack.uuid,
    );

    if (existingItem) {
      // If an item with the same uuid is found, merge properties using Object.assign
      Object.assign(existingItem, item);
    } else {
      // If no matching item is found, add it to the result
      result.push(Object.assign({}, item));
    }
  });

  return result;
};
